import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card bg-primary-div bg-opacity-10 border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "d-flex flex-wrap gap-2 justify-content-between mb-2" }
const _hoisted_7 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "ms-2" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "ms-2" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Recent Property"),
        _createElementVNode("div", {
          class: "swiper-pagination3 text-end",
          style: {"width":"100px"}
        })
      ], -1)),
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        spaceBetween: 24,
        centeredSlides: false,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        pagination: {
          el: '.swiper-pagination3',
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1199: {
            slidesPerView: 2,
          },
          1400: {
            slidesPerView: 1,
          },
          1600: {
            slidesPerView: 1,
          },
          1700: {
            slidesPerView: 2,
          },
        },
        modules: _ctx.modules,
        class: "recent-property-slide"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.propertys, (property) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: property.id,
              class: "bg-white p-2 rounded-3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: property.image,
                  class: "rounded-3",
                  alt: "property"
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h3", _hoisted_5, "$" + _toDisplayString(property.price), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(property.location), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("a", {
                      href: "#",
                      class: "fs-14 text-primary fw-medium text-decoration-none"
                    }, " View More ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-hotel-bed-line fs-18 text-primary" }, null, -1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(property.bed) + " Bed", 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-showers-line fs-18 text-primary" }, null, -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(property.bath) + " Bath", 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-square-line fs-18 text-primary" }, null, -1)),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(property.sqft) + " sqft", 1)
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}